import { useMemo } from 'react';

import { useConnect } from './useConnect';
import { Toggle } from '../../../components';
import { PermissionCheck } from '../../../shared';
import { FormItem, Form } from '../../../components';
import { Datepicker, Dropdown } from '../../../components';
import { Input, SubmitButton, Loading } from '../../../components';
import type { ConnectFormProps } from './useConnect';

type ConnectProps = {
  agents: ShortAgentType[];
};

const GoogleConnect: React.FC<ConnectProps> = ({ agents }) => {
  const { onChange, form, handleCall, isCalling } = useConnect(agents);

  const options = useMemo(() => {
    const result: OptionType[] = [
      ...agents.map(agent => ({ value: agent.id, label: agent.name })),
    ];

    return result;
  }, [agents]);

  if (isCalling) return <Loading />;

  return (
    <div className="flex items-start justify-center grow min-h-[80vh] px-4">
      <Form onChange={onChange} initialValue={form as ConnectFormProps}>
        <div className="flex flex-col gap-y-4 flex-1 max-w-[50rem]">
          <FormItem<ConnectFormProps>
            required
            label="Agent"
            inline={false}
            name="agent_id"
            className="w-full"
          >
            <Dropdown options={options} />
          </FormItem>

          <FormItem<ConnectFormProps>
            required
            inline={false}
            name="meet_link"
            className="w-full"
            label="Conference Call URL"
          >
            <Input placeholder="Google Meet, Zoom, Teams, WebEx" />
          </FormItem>

          <FormItem<ConnectFormProps>
            name="bot_name"
            label="Agent Name"
            className="w-full"
            inline={false}
          >
            <Input placeholder="Agent Name" />
          </FormItem>
          <FormItem<ConnectFormProps>
            name="bg_info"
            inline={false}
            className="w-full"
            label="Conference Call Background Info"
            // tooltip="Make sure to use {ConferenceCallInfo} variable in Agent's prompt so it's aware about this data"
          >
            <Input multiline placeholder="Conference Call Background Info" />
          </FormItem>

          <FormItem<ConnectFormProps>
            inline={false}
            className="w-full"
            name="knowledgeBaseId"
            label="Knowledge Base Id"
          >
            <Input placeholder="Knowledge Base Id" />
          </FormItem>

          <PermissionCheck action="admin">
            <FormItem<ConnectFormProps>
              inline={false}
              name="bg_info_id"
              label="Bg Info Id"
              className="w-full"
            >
              <Input placeholder="Bg Info Id" />
            </FormItem>
          </PermissionCheck>

          <FormItem<ConnectFormProps>
            inline={false}
            name="presentation_id"
            label="Presentation Id"
            className="w-full"
          >
            <Input placeholder="Presentation Id" />
          </FormItem>

          <FormItem<ConnectFormProps>
            inline={false}
            className="w-full"
            name="join_at"
            label="Join At - (leave empty if now)"
          >
            <Datepicker minDate={new Date()} disableClock />
          </FormItem>

          <FormItem<ConnectFormProps>
            inline={false}
            className="w-full"
            name="enable_video_avatar_mode"
            label="Enable Video Avatar Mode"
          >
            <Toggle />
          </FormItem>

          <div className="flex justify-end w-full">
            <SubmitButton
              children="Call"
              style="primary"
              disabled={isCalling}
              onClick={handleCall}
            />
          </div>
        </div>
      </Form>
    </div>
  );
};

export default GoogleConnect;
